<template>
  <v-app>
    <div class="public-site">
      <header class="public-header">
        <div class="public-wrap public-header-inner">
          <a href="/" class="brand" aria-label="Home">
            <brand-logo variant="on-dark" size="md" />
          </a>

          <nav class="public-nav d-none d-md-flex">
            <a href="/ride"><brand-product kind="ride" /></a>
            <a href="/register"><brand-product kind="school" /></a>
            <a href="/#download">Download</a>
            <a href="/#help">Contact</a>
          </nav>

          <div class="header-actions">
            <language-switch tone="on-dark" />
            <a class="btn btn-ghost d-none d-sm-inline-flex" href="/signin">Sign in</a>
            <a class="btn btn-gold" href="/register">Sign up</a>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon dark class="d-md-none" v-bind="attrs" v-on="on">
                  <v-icon>mdi-menu</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item href="/ride"><brand-product kind="ride" /></v-list-item>
                <v-list-item href="/register"><brand-product kind="school" /></v-list-item>
                <v-list-item href="/#download">Download</v-list-item>
                <v-list-item href="/#help">Contact</v-list-item>
                <v-list-item href="/signin">Sign in</v-list-item>
                <v-list-item href="/register">Sign up</v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>
      </header>

      <v-main>
        <slot></slot>
      </v-main>

      <footer class="public-footer">
        <div class="public-wrap footer-inner">
          <a href="/" class="footer-brand" aria-label="Home">
            <brand-logo variant="on-dark" size="md" />
            <span class="footer-domain">ridelilo.com</span>
          </a>
          <div class="footer-links">
            <router-link to="/about">{{ $t('public_nav_about') }}</router-link>
            <router-link to="/contact">{{ $t('contact_us') }}</router-link>
            <router-link to="/privacy">{{ $t('Privacy Policy') }}</router-link>
            <router-link to="/terms">{{ $t('Terms & Conditions') }}</router-link>
          </div>
        </div>
      </footer>
    </div>
  </v-app>
</template>

<script>
import BrandLogo from '@/components/BrandLogo.vue'
import BrandProduct from '@/components/BrandProduct.vue'
import LanguageSwitch from '@/components/LanguageSwitch.vue'

export default {
  components: { BrandLogo, BrandProduct, LanguageSwitch },
}
</script>

<style lang="scss" scoped>
.public-site {
  min-height: 100vh;
  background: var(--canvas);
  color: var(--navy);
  display: flex;
  flex-direction: column;
  font-family: var(--font);
}

.public-wrap {
  width: min(1160px, calc(100% - 36px));
  margin: 0 auto;
}

.public-header {
  position: sticky;
  top: 0;
  z-index: 5;
  background: var(--navy);
}

.public-header-inner,
.header-actions,
.brand,
.footer-brand {
  display: flex;
  align-items: center;
}

.public-header-inner {
  min-height: 76px;
  gap: 28px;
}

.public-nav {
  gap: 22px;
  flex: 1;
}

.public-nav a {
  color: rgba(255, 255, 255, 0.92);
  text-decoration: none;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.01em;
}

.public-nav a:hover { color: var(--gold); }

.header-actions {
  margin-left: auto;
  gap: 10px;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  padding: 11px 18px;
  font-weight: 700;
  font-size: 13px;
  text-decoration: none;
  line-height: 1;
}
.btn-ghost {
  background: transparent;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, .28);
}
.btn-gold {
  background: var(--gold);
  color: var(--navy);
  border: 0;
}

.public-site ::v-deep .auth-wrapper {
  min-height: auto;
  padding: 12px 0 36px;
}

.public-footer {
  margin-top: auto;
  background: var(--navy);
  padding: 36px 0 28px;
}

.footer-inner {
  display: flex;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
  align-items: center;
}

.footer-brand {
  gap: 14px;
  text-decoration: none;
}

.footer-domain {
  color: var(--gold);
  font-size: 0.92rem;
  font-weight: 600;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.72);
  text-decoration: none;
}
</style>
